import useSearchQuestionsInfinite from '@/entities/qna/hook/useSearchQuestionsInfinite';
import { QnaRealtimeQueries } from '@/entities/qna/model/realtime';
import useCustomRouter from '@/hooks/useCustomRouter';
import { RealtimeQnaCardVo } from '@/types/qna';
import { useMemo } from 'react';

interface RealtimeWebViewQnaViewModel {
  queries: QnaRealtimeQueries;
  questions: RealtimeQnaCardVo[];
  isQnaListLoading: boolean;
  totalPage: number;
  hasNextPage: boolean;
  fetchNextPage: () => void;
}

const DEFAULT_SIZE = 20;
const useRealtimeWebViewQnaViewModel = (): RealtimeWebViewQnaViewModel => {
  const { router } = useCustomRouter();

  const { categoryId = '', page = '1' } = router.query as QnaRealtimeQueries;

  const selectedCategoryIds = useMemo(() => {
    return categoryId ? [categoryId] : [];
  }, [categoryId]);

  const {
    questions: questions,
    isLoading,
    hasNextPage,
    fetchNextPage,
    totalPage,
  } = useSearchQuestionsInfinite({
    categoryIds: selectedCategoryIds,
    page: Number(page),
    size: DEFAULT_SIZE,
  });

  return {
    queries: {
      categoryId,
      page,
    },
    questions: questions,
    isQnaListLoading: isLoading,
    totalPage,
    hasNextPage,
    fetchNextPage,
  };
};

export default useRealtimeWebViewQnaViewModel;
